
export const cleanupStep1 = (data) => {
  const cleanedData = { ...data };
  
  // Очистка адресов
  if (cleanedData.child.sameFactAddress === "yes") {
    cleanedData.child.addressFact = "";
  }
  
  // Нормализация ФИО - убираем лишние пробелы
  if (cleanedData.child.lastName) {
    cleanedData.child.lastName = cleanedData.child.lastName.replace(/\s+/g, ' ').trim();
  }
  if (cleanedData.child.firstName) {
    cleanedData.child.firstName = cleanedData.child.firstName.replace(/\s+/g, ' ').trim();
  }
  if (cleanedData.child.secondName) {
    cleanedData.child.secondName = cleanedData.child.secondName.replace(/\s+/g, ' ').trim();
  }
  
  // Валидация дат
  const birthDate = new Date(cleanedData.child.birthDate);
  const certIssueDate = new Date(cleanedData.child.birthCertificate.issueDate);
  
  if (certIssueDate < birthDate) {
    // Устанавливаем дату выдачи = дате рождения + 1 день
    const correctedDate = new Date(birthDate);
    correctedDate.setDate(correctedDate.getDate() + 1);
    //cleanedData.child.birthCertificate.issueDate = correctedDate.toISOString();
  }
  
  // Очистка файлов
  if (!cleanedData.child.birthCertificate.files || 
      !Array.isArray(cleanedData.child.birthCertificate.files)) {
    cleanedData.child.birthCertificate.files = [];
  }
  
  return cleanedData;
};